import React, { useState } from 'react';
import { Flex, Modal, Paper, Text, ThemeIcon } from '@mantine/core';
import { OneDriveIconIcon } from 'src/data-capture/file-management/drop-zone/OneDriveIcon';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { Button } from 'src/components';
import SharePointButton, {
  PickedItem,
} from 'src/data-capture/file-management/drop-zone/SharePointButton';

export default function OneDriveModal({
  opened,
  onClose,
  onPickedItems,
  fileExtensions,
}: {
  opened: boolean;
  onClose: () => void;
  onPickedItems: (items: PickedItem[]) => void;
  fileExtensions?: string[];
}) {
  const [account, setAccount] = useState<{ name?: string; username?: string } | null>(null);
  const [switchAccountRequested, setSwitchAccountRequested] = useState(false);

  return account ? (
    <Modal opened={opened} onClose={onClose}>
      <Flex align={'center'} direction={'column'}>
        <ThemeIcon radius="xl" size={68} color={'success.1'}>
          <OneDriveIconIcon size={32} />
        </ThemeIcon>
        <Text ta={'center'} mt={'xs'} fw={FONT_WEIGHTS.semibold} size={'displaySm'}>
          SharePoint
        </Text>
        <Text ta={'center'} mt={'xxs'} fw={FONT_WEIGHTS.medium} size={'textMd'}>
          Pick files directly from your connected account
        </Text>
        <Text c={'brand.8'} ta={'center'} fw={FONT_WEIGHTS.medium} size={'textMd'}>
          {account.username || account.name}
        </Text>
        <Flex mt={'lg'} gap={'xs'} direction={'column'} w={'100%'}>
          <SharePointButton
            onPickedItems={onPickedItems}
            onAccountChange={setAccount}
            switchAccountRequested={switchAccountRequested}
            onSwitchAccountHandled={() => setSwitchAccountRequested(false)}
            fileExtensions={fileExtensions}
          />
          <Button variant={'secondary'} fullWidth onClick={() => setSwitchAccountRequested(true)}>
            Switch account
          </Button>
        </Flex>
      </Flex>
    </Modal>
  ) : (
    <Modal opened={opened} onClose={onClose}>
      <Flex align={'center'} direction={'column'}>
        <ThemeIcon radius="xl" size={68} color={'gray.0'}>
          <OneDriveIconIcon size={32} />
        </ThemeIcon>
        <Text ta={'center'} mt={'xs'} fw={FONT_WEIGHTS.semibold} size={'displaySm'}>
          Connect your SharePoint account
        </Text>
        <Text ta={'center'} mt={'xxs'} fw={FONT_WEIGHTS.medium} size={'textMd'}>
          Add files directly from SharePoint to speed up reviews and data processing.
        </Text>
        <Paper radius={'lg'} bg={'gray.1'} mt={'lg'} p={'sm'}>
          <Text fw={FONT_WEIGHTS.semibold} size={'textXs'}>
            Secure connection
          </Text>
          <Text fw={FONT_WEIGHTS.medium} size={'textXs'}>
            Your connection is encrypted and can be revoked at any time through your Microsoft
            account settings.
          </Text>
        </Paper>
        <Flex mt={'lg'} gap={'xs'} direction={'column'} w={'100%'}>
          <SharePointButton
            onPickedItems={onPickedItems}
            onAccountChange={setAccount}
            switchAccountRequested={switchAccountRequested}
            onSwitchAccountHandled={() => setSwitchAccountRequested(false)}
            fileExtensions={fileExtensions}
          />
          <Button variant={'secondary'} fullWidth onClick={onClose}>
            Do this later
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
